export const SIGNIN = '/sign-in';
export const FORGETPASSWORD = '/forgot-password';
export const WELCOME = '/dashboard';
export const USERS = '/dashboard/users';
export const ADD_ARTICLE = '/dashboard/article/add';
export const EDIT_ARTICLE = '/dashboard/article/edit';
export const ARTICLES = '/dashboard/articles';
export const RECEPTIONS = '/dashboard/operations/receptions';
export const CONTAINER = '/dashboard/operations/container';
export const VALIDCONTAINERS = '/dashboard/operations/valid-container';
export const RECLASSIFY = '/dashboard/operations/reclassify';
export const CONTAINER_CLASSIFICATION = '/dashboard/operations/container-classification';
export const CONTAINER_AUDIT = '/dashboard/queries/container-audit';
